import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import './Dialog.css';

const closeBtn = (
  <button className="close">
    <i className="icon icon-close text-blue" />
  </button>
);

const Dialog = ({ id, body, closeDialog, modalOptions, showDialog }) =>
  showDialog && (
    <Modal
      className={id}
      isOpen={showDialog}
      onClose={closeDialog}
      {...modalOptions}
      centered
    >
      <ModalHeader close={closeBtn} onClick={closeDialog} />

      <ModalBody>{body}</ModalBody>
    </Modal>
  );

Dialog.propTypes = {
  id: PropTypes.string,
  body: PropTypes.object,
  modalOptions: PropTypes.object,
  showDialog: PropTypes.bool,
  closeDialog: PropTypes.func,
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js